const getCurrency = (total: number) => {
  return `Rp${new Intl.NumberFormat('id-ID').format(total)}`;
};
export default getCurrency;
